import { Shimmer, Stack } from "@fluentui/react";
import React, { CSSProperties } from "react";

type GridProps = React.PropsWithChildren<{
    dir?: "ltr" | "rtl";
    style?: CSSProperties;
    isLoading?: boolean;
}>;

export const Grid: React.FunctionComponent<GridProps> = (props: GridProps) => {
    return (
        <>
            {props.isLoading && <Shimmer />}
            {!props.isLoading && (
                <Stack className="ms-Grid" dir={props.dir} style={{ ...props.style, padding: 0 }}>
                    {props.children}
                </Stack>
            )}
        </>
    );
};

Grid.defaultProps = {
    dir: "ltr",
    isLoading: false
};
